import { Attr, BelongsTo, HasOne, HasMany, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import CandidateQualifier from "./CandidateQualifier";
import Feedback from "./Feedback";
import { JobType } from "./Job";
import Recruiter from "./Recruiter";
import Speciality from "./Speciality";

@Model()
class RecruiterUser extends ApplicationRecord {
  static jsonapiType = "recruiter_users";

  @Attr() companyId: number;

  @Attr() reassignToId: string;

  @Attr() location: string;

  @Attr() yearsExperience: number;

  @Attr() email: string;

  @Attr() mobileNumber: string;

  @Attr() linkedinUrl: string;

  @Attr() isOwner: boolean;

  @Attr() isAdmin: boolean;

  @Attr() isRecruiter: boolean;

  @Attr() firstName: string;

  @Attr() lastName: string;

  @Attr() avatar: string;

  @Attr() biography: string;

  @Attr() photo: string;

  @Attr() fullName: string;

  @Attr() invitationPending: boolean;

  @Attr() receiveJobNotificationEmails: boolean;

  @Attr() password: string;

  @Attr() passwordConfirmation: string;

  @Attr() currentPassword: string;

  @Attr() jobType: RecruiterUserJobType;

  @BelongsTo(Recruiter) recruiter: Recruiter;

  @HasOne(CandidateQualifier) candidateQualifier: CandidateQualifier;

  @HasOne(Speciality) speciality: Speciality;

  @HasMany(Feedback) feedback: Feedback;

  get isEmployer() {
    return false;
  }

  get role() {
    if (this.isOwner) {
      return "Owner";
    }

    if (this.isAdmin) {
      return "Admin";
    }

    return "Member";
  }
}

export const BothJobTypes = "";

export type RecruiterUserJobType = JobType | typeof BothJobTypes;

export default RecruiterUser;
